import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
import shared from '../../../src/shared.js';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const Note = makeShortcode("Note");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`As an organization owner or team admin, you can remove organization members from teams if they no longer need access to packages accessible to the team.`}</p>
    <ol>
      <li parentName="ol">
        <>{shared['user-login'].text}</>
        <>{shared['user-login'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['account-settings'].text}</>
        <>{shared['account-settings'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-selection'].text}</>
        <>{shared['organization-selection'].image}</>
      </li>
      <li parentName="ol">
        <>{shared['organization-teams-tab'].text}</>
        <>{shared['organization-teams-tab'].image}</>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the list of team members, find the member you want to remove.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the member row, to remove the member from the team, click `}<strong parentName="p">{`X`}</strong>{`.`}</p>
        <Screenshot src="/organizations/managing-teams/team-member-remove-button.png" alt="Screenshot of the team member remove button" mdxType="Screenshot" />
      </li>
    </ol>
    <Note mdxType="Note">
      <p><strong parentName="p">{`Note: Removing a member from a team, even if it is the only team they are a member of, will not remove them from the organization.`}</strong>{` To remove a member from the organization, see "`}<a parentName="p" {...{
          "href": "removing-members-from-your-organization"
        }}>{`Removing members from your organization`}</a>{`".`}</p>
    </Note>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      